function updateRecentlyViewed() {
  fetch("/cart.js")
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        console.error("ERROR : Unable to fetch cart data.");
      }
    })
    .then((response) => {
      console.log(response);

      var properties_value = null;
      var product_handle = document
        .querySelector("[data-product-handle]")
        .getAttribute("data-product-handle");

      console.log(product_handle);

      if (
        "attributes" in response &&
        "_recently_viewed" in response.attributes
      ) {
        properties_value = response.attributes["_recently_viewed"];
      }

      if (properties_value != null) {
        var properties_value_split = properties_value.split(",");
        if (!(properties_value_split.indexOf(product_handle) > -1)) {
          if (properties_value_split.length == 10) {
            properties_value_split.splice(0, 1);
          }
          properties_value_split.push(product_handle);
          properties_value = properties_value_split.join(",");
        }
      } else {
        properties_value = product_handle;
      }

      let formData = {
        attributes: {
          _recently_viewed: properties_value,
        },
      };
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            console.error("ERROR : Unable to update cart data.");
          }
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    })
    .catch((error) => {
      console.log("Get cart recently_viewed error : " + error);
    });
}
document.addEventListener("DOMContentLoaded", function (event) {
  updateRecentlyViewed();
});
